import React from 'react';
import { useNavigate } from 'react-router-dom';

import { ButtonContainer, Text } from './EmailDisclaimerModal.styled';
import { Button } from 'components/v2/Buttons/Button/Button';
import { Modal } from 'components/v2/Modal/Modal';
import { pageUrl } from 'utilities/pageUrl';

import { EmailDisclaimerModalProps } from './EmailDisclaimerModal.types';

export const EmailDisclaimerModal = ({ open, onClose }: EmailDisclaimerModalProps) => {
  const navigate = useNavigate();

  if (!open) return null;

  return (
    <Modal title="Account changes" open={open} onCancel={onClose}>
      <Text>
        You will be prompted to reset your password as part of this process. Do you want to
        continue?
      </Text>
      <ButtonContainer>
        <Button label={'Cancel'} category="primary-dark" size="lg" onClick={() => onClose()} />
        <Button
          label={'Continue'}
          category="primary"
          size="lg"
          onClick={() => navigate(pageUrl.changeEmail())}
        />
      </ButtonContainer>
    </Modal>
  );
};
